export const pptoPdf = (pid, bid) => new Promise((resolve, reject) => {
  const f = document.createElement("iframe");
  f.style.cssText = "position:fixed;left:-10000px;top:0;width:900px;height:1400px;border:0;";
  f.src = `/pacientes/${pid}/presupuesto?id=${bid}&pdf=1`;
  const done = (fn, v) => { window.removeEventListener("message", on); clearTimeout(t); f.remove(); fn(v); };
  const on = (e) => {
    if (e.origin !== window.location.origin || e.data?.type !== "ppto-pdf" || e.data.id !== bid) return;
    if (e.data.error) done(reject, new Error("No se pudo generar el PDF del presupuesto"));
    else done(resolve, { presupuesto_id: bid, pdf_base64: e.data.b64, filename: e.data.filename });
  };
  const t = setTimeout(() => done(reject, new Error("El PDF del presupuesto tardó demasiado")), 45000);
  window.addEventListener("message", on);
  document.body.appendChild(f);
});
